module.exports = "\t\t<footer class=\"col-lg-12 pied\">\n\t\t  SAGE - Gestion de ruchers V1.1.4 - Assistance : Roland au 0608764415\n\t\t</footer>\n\n\t\t<!-- 1.1.4 : correction pb de date (fin de mois + enr en prod) -->"


//////////////////
// WEBPACK FOOTER
// ./src/app/pied/pied.component.html
// module id = ./src/app/pied/pied.component.html
// module chunks = main